var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"map",staticStyle:{"height":"470px"},attrs:{"id":"regularMap"}})])])
}]

export { render, staticRenderFns }